import { Grid } from "@mui/material";
import AcxSwitch from "components/UI/AcxSwitch";
import { observer } from "mobx-react";
import React from "react";
import { LLMClassifiersStore } from "../LLMClassifiers/Stores/LLMClassifiersStore";
import { ClassifierBuilderV2Store } from "../ClassifierBuilderV2/Stores/ClassifierBuilderV2Store";

interface ShowUnpublishedSwitchProps {
    store: LLMClassifiersStore | ClassifierBuilderV2Store;
}

export const ShowUnpublishedSwitch = observer(function (
    props: ShowUnpublishedSwitchProps,
) {
    return (
        <Grid container columnGap={1} flexWrap="nowrap" alignItems="center">
            <Grid item>
                <AcxSwitch
                    sx={{ margin: 0 }}
                    checked={props.store.showUnpublished}
                />
            </Grid>
            <Grid item>Show Unpublished</Grid>
        </Grid>
    );
});
